import { render, staticRenderFns } from "./receipt-info-detail.vue?vue&type=template&id=193648f4&scoped=true"
import script from "./receipt-info-detail.vue?vue&type=script&lang=js"
export * from "./receipt-info-detail.vue?vue&type=script&lang=js"
import style0 from "./receipt-info-detail.vue?vue&type=style&index=0&id=193648f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193648f4",
  null
  
)

export default component.exports